import { combineReducers } from 'redux';
import initializePurchase from './InitializePurchaseReducers';
import finalizePurchase from './FinalizePurchaseReducers';
import settings from './SettingsReducers';
import offerDetails from './OfferDetailsReducers';
import { pageState } from 'reducers/PageStateReducers';

const rootReducer = combineReducers({
  settings,
  initializePurchase,
  finalizePurchase,
  pageState,
  offerDetails,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/payments/reducers/links.js